<template>
    <section
        v-bind="$attrs"
        class="bg-gradient-to-t from-transparent via-accent/10 via-35% to-transparent">
        <AtomTitle
            v-if="!hideFreeDelivery"
            :class="fontSizeLgTitle === 'medium' ? 'lg:!text-32/100' : ''"
            class="container">
            {{ getCalculatorTitle(directionSlug) }}
        </AtomTitle>

        <div class="container flex h-full w-full flex-col gap-3 lg:gap-5">
            <div
                :class="hideFreeDelivery ? '' : 'mt-10'"
                class="relative flex gap-5 max-lg:justify-center">
                <div class="basis-full lg:basis-1/2">
                    <div
                        :class="hideFreeDelivery ? 'space-y-6' : 'space-y-5'"
                        class="rounded-12 bg-calculator-form p-3 pb-5">
                        <AtomTitle
                            v-if="hideFreeDelivery"
                            class="lg:!text-32/100 lg:max-xl:max-w-[27rem] xl:!text-[2.9rem]">
                            {{ getCalculatorTitle(directionSlug) }}
                        </AtomTitle>
                        <div
                            ref="calculatorForm"
                            :style="{
                                '--form-height': calculatorFormHeight + 'px',
                            }"
                            class="relative h-[--form-height] transition-all duration-300">
                            <div
                                :class="
                                    hideFreeDelivery
                                        ? 'justify-end space-y-7'
                                        : 'space-y-5'
                                "
                                class="absolute flex h-full w-full flex-col">
                                <div
                                    v-for="field in [...calculator.fields].sort(
                                        (
                                            a: ICalculatorSettingField,
                                            b: ICalculatorSettingField
                                        ) =>
                                            calculator.fields_order.indexOf(
                                                a.slug
                                            ) -
                                            calculator.fields_order.indexOf(
                                                b.slug
                                            )
                                    )"
                                    :key="field.slug"
                                    ref="fieldElements"
                                    :style="{
                                        '--field-height':
                                            fieldsHeight[field.slug] + 'px',
                                    }"
                                    :hidden="hiddenFields[field.slug]"
                                    :class="{
                                        '!mt-0 !h-0 overflow-hidden opacity-0':
                                            hiddenFields[field.slug] &&
                                            fieldsHeight[field.slug],
                                        '!mt-0':
                                            calculator.fields_order.indexOf(
                                                field.slug
                                            ) === 0,
                                    }"
                                    :data-field-slug="field.slug"
                                    class="flex h-[--field-height] justify-between transition-all duration-300 max-sm:flex-col">
                                    <div
                                        v-html="field.title"
                                        class="flex basis-1/3 items-center" />
                                    <div
                                        class="w-full max-sm:mt-2 sm:max-w-[65%] sm:pl-5">
                                        <AtomDropdown
                                            v-if="field.options"
                                            v-model="selectedValues[field.slug]"
                                            icon-position="right"
                                            :disabled="
                                                disabledFields[field.slug]
                                            "
                                            :options="
                                                getDropdownOptions(
                                                    field.options || []
                                                )
                                            "
                                            class="w-full"
                                            @change="
                                                handleUpdate(field.slug)
                                            " />
                                        <AtomField
                                            v-else
                                            v-model="
                                                editableFieldValues[field.slug]
                                            "
                                            type="number"
                                            input-mode="numeric"
                                            :min="field.min_count || 0"
                                            :defer-number-validation="true"
                                            :disabled="
                                                disabledFields[field.slug]
                                            "
                                            :max="field.max_count"
                                            @change="
                                                commitCalculatorFieldValue(
                                                    field.slug
                                                )
                                            " />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <template v-if="!hideFreeDelivery">
                            <AtomHr class="!p-0" />
                            <div class="font-semibold">
                                Бесплатно доставим до Вашего адреса в любом
                                городе РФ при заказе от 50&nbsp;000&nbsp;₽.
                            </div>
                        </template>
                    </div>
                </div>
                <div
                    class="absolute right-0 top-0 hidden h-full max-h-[41.625rem] w-[calc(50%_-_1.25rem)] grid-cols-2 grid-rows-2 gap-5 lg:grid">
                    <CalculatorImage
                        v-for="imageSetting in calculator.images"
                        :key="imageSetting.counter_from"
                        :align="imageSetting.align"
                        :size="imageSetting.size"
                        :hide-count="imageSetting.hide_count"
                        :count="selectedValues[imageSetting.counter_from] || 0"
                        :success-icon="imageSetting.success_icon"
                        :image="getImage(imageSetting).png"
                        :image-webp="getImage(imageSetting).webp" />
                </div>
            </div>
            <div>
                <form
                    class="flex rounded-12 bg-accent-100/10 p-3 max-lg:flex-col lg:space-x-5 lg:backdrop-blur-sm xl:space-x-11"
                    @submit.prevent="handleForm">
                    <div
                        class="flex max-lg:flex-col max-lg:space-y-5 lg:w-full lg:max-w-[50%] lg:space-x-5 lg:pb-3">
                        <div class="flex w-full flex-col space-y-5">
                            <AtomField
                                v-model="formData.name"
                                placeholder="Ваше имя"
                                :error="errors.name">
                            </AtomField>
                            <AtomField
                                v-model="formData.phone"
                                placeholder="Телефон"
                                :error="errors.phone"
                                @input="
                                    validatePhone(formData, errors, $event)
                                ">
                            </AtomField>
                            <AtomField
                                v-model="formData.email"
                                placeholder="Электронная почта"
                                :error="errors.email"
                                @input="validateEmail(formData, errors)">
                            </AtomField>
                        </div>
                        <AtomTextarea
                            v-model="formData.message"
                            placeholder="Комментарий"
                            :error="errors.message"
                            class="min-h-32 w-full max-sm:min-h-40"></AtomTextarea>
                    </div>
                    <div
                        class="flex flex-col py-3 lg:max-w-[26.875rem] xl:max-w-[36.875rem]">
                        <div
                            class="flex items-baseline gap-3 text-32/100 font-semibold max-md:flex-col">
                            <div class="flex space-x-3">
                                <p>Итого:</p>
                                <p v-html="totalPrice"></p>
                            </div>

                            <span
                                v-if="isMinPrice"
                                class="text-12/100 xl:text-16/148">
                                (минимальная стоимость заказа)
                            </span>
                        </div>
                        <p
                            class="mt-3 text-16/148 font-medium text-accent-100 lg:min-h-24 xl:min-h-[4.5rem]"
                            v-html="totalDescription"></p>
                        <div
                            class="mt-3 flex items-center max-md:flex-col max-md:space-y-5 md:space-x-5 xl:mt-auto">
                            <AtomButton
                                type="submit"
                                class="w-full"
                                appearance="light">
                                Отправить заявку
                            </AtomButton>

                            <BaseCheckbox
                                required
                                :error="errors.termsAccepted"
                                v-model="formData.termsAccepted"
                                class="!w-full shrink-0 md:max-w-[220px]"
                                @click="errors.termsAccepted = false">
                                <span
                                    class="inline-block text-12/140 text-ash-200 max-md:text-left">
                                    Я даю&nbsp;согласие на
                                    <NuxtLink
                                        target="_blank"
                                        href="/pdf/soglasie.pdf"
                                        class="underline underline-offset-4">
                                        обработку персональных данных
                                    </NuxtLink>
                                </span>
                            </BaseCheckbox>
                        </div>
                    </div>
                </form>
                <div
                    :style="`height: ${heightErrorBlock}px`"
                    :class="heightErrorBlock ? '' : 'overflow-hidden'"
                    class="pt-2 transition-all duration-200 md:pt-5">
                    <div
                        ref="blockMessageError"
                        class="rounded-8 border border-red-600 bg-red-600/20 px-4 py-3 backdrop-blur-sm">
                        <p class="text-center text-12/140">
                            Чтобы отправить форму, нужно заполнить все поля
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <CalculateModal
            v-model="selectedValues"
            :calculator
            :hidden-fields
            :total-price
            @handle-update="handleUpdate" />
    </section>
</template>

<script setup lang="ts">
import { useWindowSize } from '@vueuse/core'
import type { PropType } from 'vue'
import { getCalculatorTitle } from '~/services/calculator.service'
import type {
    ICalculatorFieldModal,
    ICalculatorImageSetting,
    ICalculatorOption,
    ICalculatorSelectedValues,
    ICalculatorSetting,
    ICalculatorSettingField,
} from '~/types/calculator.types'
import type {
    TCromiRentDirectionSlug,
    TCromiRentRadioguidesDirectionSlug,
    TDirectionSlug,
} from '~/types/global.types'

import AtomButton from '~/components/atom/atom-button/AtomButton.vue'
import AtomDropdown from '~/components/atom/atom-dropdown/AtomDropdown.vue'
import type { IDropdownOption } from '~/components/atom/atom-dropdown/atom-dropdown.types'
import AtomField from '~/components/atom/atom-field/AtomField.vue'
import AtomHr from '~/components/atom/atom-hr/AtomHr.vue'
import AtomTextarea from '~/components/atom/atom-textarea/AtomTextarea.vue'
import AtomTitle from '~/components/atom/atom-title/AtomTitle.vue'
import BaseCheckbox from '~/components/base/base-checkbox/BaseCheckbox.vue'
import CalculateModal from '~/components/modals/calculate-modal/CalculateModal.vue'
import CalculatorImage from '~/components/particles/calculator-section/CalculatorImage.vue'

import { errorHandling } from '~/utils/error-handling'
import { validateEmail, validatePhone } from '~/utils/validations'

const props = defineProps({
    calculator: {
        type: Object as PropType<ICalculatorSetting>,
        required: true,
    },
    directionSlug: {
        type: String as PropType<
            | TDirectionSlug
            | TCromiRentDirectionSlug
            | TCromiRentRadioguidesDirectionSlug
        >,
        required: true,
    },
    hideFreeDelivery: {
        type: Boolean,
        default: false,
    },
    fontSizeLgTitle: {
        type: String as PropType<'default' | 'medium'>,
        default: 'default',
    },
})

//  FORM
const blockMessageError = ref<HTMLElement | null>(null)
const modalStore = useModalStore()

const formData = reactive({
    name: '',
    phone: '',
    email: '',
    message: '',
    termsAccepted: false,
})

const errors = reactive({
    name: '',
    phone: '',
    email: '',
    message: '',
    termsAccepted: false,
})

const heightErrorBlock = computed<number>(() => {
    if (!blockMessageError.value) return 0

    return errors.name || errors.phone || errors.email || errors.message
        ? blockMessageError.value.getBoundingClientRect().height + 20
        : 0
})

async function handleForm() {
    if (!validateData()) return

    if (
        !errors.name.length &&
        !errors.phone.length &&
        !errors.email.length &&
        !errors.message.length
    ) {
        const utmParams = useCookie<Record<string, any> | null>('utm')

        const { error } = await useApiFetch('/v1/callbacks', {
            method: 'POST',
            key: `callback-${Date.now()}`,
            body: JSON.stringify({
                name: formData.name,
                phone: formData.phone,
                email: formData.email,
                message: formData.message,
                form: 'Калькулятор',
                order: getOrder(),
                href: location.href,
            }),
            query: utmParams.value || undefined,
        })

        console.log('Error', error)

        if (error.value && error.value?.data) {
            errorHandling(error.value, errors)

            return
        }

        clearErrors()
        clearData()
        modalStore.close('costSet')
    }
}

function validateData() {
    let errorCounter = 0

    if (!formData.name.length) {
        errors.name = 'Заполните поле'
        errorCounter += 1
    } else {
        errors.name = ''
    }

    if (!formData.phone.length) {
        errors.phone = 'Заполните поле'
        errorCounter += 1
    } else {
        errors.phone = ''
    }

    if (!formData.message.length) {
        errors.message = 'Заполните поле'
        errorCounter += 1
    } else {
        errors.message = ''
    }

    if (!formData.termsAccepted) {
        errors.termsAccepted = true
        errorCounter += 1
    } else {
        errors.termsAccepted = false
    }

    const isEmail = new RegExp(/^\S+@\S+\.\S+$/, 'i')

    if (!formData.email.length) {
        errors.email = 'Заполните поле'
        errorCounter += 1
    } else if (!isEmail.test(formData.email)) {
        errors.email = 'Неверный формат почты'
        errorCounter += 1
    } else {
        errors.email = ''
    }

    //  все ок?
    return !errorCounter
}

function clearErrors() {
    errors.name = ''
    errors.phone = ''
    errors.email = ''
    errors.message = ''
    errors.termsAccepted = false
}

function clearData() {
    formData.name = ''
    formData.phone = ''
    formData.email = ''
    formData.message = ''
    formData.termsAccepted = false
}
//  END FORM

const calculatorForm = ref<HTMLElement | null>(null)
const fieldElements = ref<HTMLElement[]>([])
const calculatorFormHeight = ref<number>(0)
const fieldsHeight = reactive<{ [key: string]: number }>({})

const selectedValues = reactive<ICalculatorSelectedValues>({})
const editableFieldValues = reactive<Record<string, string | number>>({})
const disabledFields = reactive<{ [key: string]: boolean }>({})
const hiddenFields = reactive<{ [key: string]: boolean }>({})

if (props.calculator) {
    props.calculator.fields.forEach((field: ICalculatorSettingField) => {
        selectedValues[field.slug] = props.calculator.default_values[field.slug]
        editableFieldValues[field.slug] =
            props.calculator.default_values[field.slug]
        disabledFields[field.slug] = field.default_disabled
        hiddenFields[field.slug] = field.default_hidden
    })
}

watch(hiddenFields, updateCalculatorFormHeight, { immediate: true })

watch(
    selectedValues,
    () => {
        props.calculator.fields.forEach((field: ICalculatorSettingField) => {
            handleUpdate(field.slug)
        })
    },
    { immediate: true, once: true }
)

const totalPrice = computed<string>(() => {
    return props.calculator.getPrice(props.calculator, { ...selectedValues })
})

const isMinPrice = computed<boolean>(() => {
    if (props.directionSlug !== 'arenda-radioguides') return false

    const city = String(selectedValues.city)
    const minimums = props.calculator.meta?.minimums as
        | {
              spb?: string
              moscow?: string
          }
        | undefined

    const minimumPriceSlug =
        city === '1'
            ? minimums?.moscow || 'MinMos'
            : city === '2'
              ? minimums?.spb || 'MinSpb'
              : null

    if (!minimumPriceSlug) return false

    const price = Number(
        totalPrice.value.replace('&nbsp;₽', '').replace(/\s/g, '')
    )

    return price === Number(props.calculator.prices[minimumPriceSlug] || 0)
})

const totalDescription = computed<string>(() => {
    if (props.calculator.getTotalDescription) {
        return props.calculator.getTotalDescription(props.calculator, {
            ...selectedValues,
        })
    }

    return 'Наши менеджеры ознакомятся с&nbsp;заявкой и&nbsp;свяжутся с&nbsp;вами для уточнения деталей'
})

function setFieldHeight(): void {
    if (!calculatorForm.value || !fieldElements.value.length) return

    for (const field of fieldElements.value) {
        const fieldSlug: string | null = field.getAttribute('data-field-slug')

        if (fieldSlug && field.clientHeight) {
            field.style['height'] = 'auto'
            fieldsHeight[fieldSlug] = field.clientHeight
            field.style['height'] = ''
        }
    }
}

const { width } = useWindowSize()

function updateCalculatorFormHeight(): void {
    if (!calculatorForm.value || !fieldElements.value.length) return

    setFieldHeight()

    let titleHeight = 0
    if (props.hideFreeDelivery) {
        titleHeight = width.value >= 1024 ? 32 : 0
    }

    let openFieldsHeight = 0

    for (const field of fieldElements.value) {
        const fieldSlug: string | null = field.getAttribute('data-field-slug')

        if (fieldSlug && !hiddenFields[fieldSlug] && fieldsHeight[fieldSlug]) {
            openFieldsHeight += fieldsHeight[fieldSlug]
        }
    }

    const gapSize =
        parseFloat(getComputedStyle(document.documentElement).fontSize) *
        (props.hideFreeDelivery ? 1.75 : 1.25)

    const notHiddenFieldsCount = Object.values(hiddenFields).filter(
        (value) => !value
    ).length

    calculatorFormHeight.value =
        openFieldsHeight + titleHeight + gapSize * (notHiddenFieldsCount - 1)
}

function getDropdownOptions(
    fieldsOptions: ICalculatorOption[]
): IDropdownOption[] {
    return [...fieldsOptions].map((option: ICalculatorOption) => {
        return {
            text: option.name,
            value: option.calculator_variable_name,
        }
    })
}

function getFieldSettings(
    fieldSlug: string
): ICalculatorSettingField | undefined {
    return props.calculator.fields.find(
        (field: ICalculatorSettingField) => field.slug === fieldSlug
    )
}

function normalizeCalculatorFieldValue(fieldSlug: string): number {
    const field = getFieldSettings(fieldSlug)
    const rawValue = editableFieldValues[fieldSlug]
    const minValue = Number(field?.min_count || 0)
    const maxValue =
        field?.max_count === null || field?.max_count === undefined
            ? null
            : Number(field.max_count)

    let normalizedValue =
        typeof rawValue === 'number' ? rawValue : Number.parseInt(rawValue, 10)

    if (Number.isNaN(normalizedValue)) {
        normalizedValue = minValue
    }

    if (normalizedValue < minValue) {
        normalizedValue = minValue
    } else if (maxValue !== null && normalizedValue > maxValue) {
        normalizedValue = maxValue
    }

    if (!Number.isInteger(normalizedValue)) {
        normalizedValue = Math.round(normalizedValue)
    }

    return normalizedValue
}

function syncEditableFieldValue(fieldSlug: string): void {
    editableFieldValues[fieldSlug] = selectedValues[fieldSlug]
}

function commitCalculatorFieldValue(fieldSlug: string): void {
    const normalizedValue = normalizeCalculatorFieldValue(fieldSlug)

    editableFieldValues[fieldSlug] = normalizedValue
    selectedValues[fieldSlug] = normalizedValue
    handleUpdate(fieldSlug)
}

/**
 * Обрабатывает обновление значений в зависимости от других полей
 *
 * Если в настройках калькулятора задан апдейтер, то мы запускаем эту функцию,
 * на выходе которой нам приходит массив в котором
 * либо "поле для обновления" и "блокировка поля",
 * либо "поле для обновления", "новое значение", "блокировка поля"
 *
 * @param { string } fieldSlug слаг измененного поля
 */
function handleUpdate(fieldSlug: string): void {
    if (!(fieldSlug in props.calculator.updaters)) return

    props.calculator.updaters[fieldSlug]({
        ...selectedValues,
    }).forEach(
        ([updateFieldSlug, newValue, disabled, hidden]: [
            string,
            string | number,
            boolean,
            boolean,
        ]) => {
            selectedValues[updateFieldSlug] = newValue
            syncEditableFieldValue(updateFieldSlug)
            disabledFields[updateFieldSlug] = disabled
            hiddenFields[updateFieldSlug] = hidden
        }
    )
}

/**
 * Получает изображение по выбранным значениям полей
 *
 * @param { ICalculatorImageSetting } imageSetting сеттинг картинок калькулятора
 *
 * @return возращает ссылку на изображение или null
 */
function getImage(imageSetting: ICalculatorImageSetting): {
    png: string | null
    webp: string | null
} {
    for (const fieldImage of imageSetting.images) {
        const values = Object.entries(fieldImage.values).filter(
            (fieldSlug_value: [string, string]) => {
                return fieldSlug_value[1] !== 'all'
            }
        )
        if (!values.length) {
            return { png: fieldImage.image, webp: fieldImage.image_webp }
        }

        const checkedValues = values.map(
            (fieldSlug_value: [string, string]) => {
                return (
                    String(selectedValues[fieldSlug_value[0]]) ===
                    fieldSlug_value[1]
                )
            }
        )

        if (!checkedValues.includes(false)) {
            return { png: fieldImage.image, webp: fieldImage.image_webp }
        }
    }

    return { png: null, webp: null }
}

function getOrder() {
    const values = []

    const fields: ICalculatorFieldModal[] =
        props.calculator.fields_modal.filter((field: ICalculatorFieldModal) =>
            field.prevent_hidden ? true : !hiddenFields[field.slug]
        )

    for (const field of fields) {
        values.push({
            title: getFieldTitle(field.slug),
            value:
                field.type === 'select'
                    ? getSelectValue(
                          field.slug,
                          selectedValues[field.slug] as string
                      )
                    : selectedValues[field.slug],
        })
    }

    const text =
        values.map((field) => `${field.title}: ${field.value}`).join('\n') +
        `\n\nИтоговая предварительная стоимость: ${totalPrice.value}`

    return text.replaceAll('<br/>', ' ').replaceAll('&nbsp;', ' ')
}

function getSelectValue(slug: string, value: string): string {
    const field = props.calculator.fields.find(
        (field: ICalculatorSettingField) => field.slug === slug
    )
    if (!field?.options) return ''

    const option = field.options.find(
        (option: ICalculatorOption) => option.calculator_variable_name === value
    )

    return option?.name || ''
}

function getFieldTitle(slug: string): string {
    const field = props.calculator.fields.find(
        (field: ICalculatorSettingField) => field.slug === slug
    )

    return field?.title || ''
}

let windowWidth = typeof window !== 'undefined' ? window.innerWidth : 0

function handleResize() {
    if (window.innerWidth !== windowWidth) {
        windowWidth = window.innerWidth
        updateCalculatorFormHeight()
    }
}

onMounted(() => {
    setFieldHeight()
    updateCalculatorFormHeight()
    window.addEventListener('resize', handleResize)
})

onBeforeUnmount(() => {
    window.removeEventListener('resize', handleResize)
})
</script>
